import { Routes } from '@angular/router';
import { seoSegments, type CountryCode } from '@handyhand/i18n';

export function buildRecyclingIndexRoutes(country: CountryCode): Routes {
  const seg = seoSegments(country);
  return [
    {
      path: `${seg.section.recycling}/${seg.suffix.recyclingCenters}-${seg.word.overview}/${seg.section.index}`,
      loadComponent: () =>
        import(
          '@app/pages/recycling/recycling-station-detail/recycling-station-detail-index/recycling-index.component'
        ).then((c) => c.RecyclingIndexComponent),
      data: { indexType: 'recycling-overview' },
    },
    {
      path: `${seg.section.recycling}/${seg.suffix.recyclingCenter}/${seg.section.index}`,
      loadComponent: () =>
        import(
          '@app/pages/recycling/recycling-station-detail/recycling-station-detail-index/recycling-index.component'
        ).then((c) => c.RecyclingIndexComponent),
      data: { indexType: 'recycling-center' },
    },
    {
      path: `${seg.section.gardenTrash}/${seg.suffix.gardenTrash}/${seg.section.index}`,
      loadComponent: () =>
        import(
          '@app/pages/recycling/recycling-station-detail/recycling-station-detail-index/recycling-index.component'
        ).then((c) => c.RecyclingIndexComponent),
      data: { indexType: 'garden-trash' },
    },
    {
      path: `${seg.section.bulkTrash}/${seg.suffix.bulkyWaste}/${seg.section.index}`,
      loadComponent: () =>
        import(
          '@app/pages/recycling/recycling-station-detail/recycling-station-detail-index/recycling-index.component'
        ).then((c) => c.RecyclingIndexComponent),
      data: { indexType: 'bulk-trash' },
    },
  ];
}

export function buildRecyclingRoutes(country: CountryCode): Routes {
  const seg = seoSegments(country);
  return [
    ...buildRecyclingIndexRoutes(country),
    {
      path: `${seg.section.recycling}/:regionSlug/:citySlug/${seg.suffix.recyclingCenters}`,
      loadComponent: () =>
        import(
          '@app/pages/recycling/recycling-station-overview-city/recycling-overview-city.component'
        ).then((c) => c.RecyclingOverViewCityComponent),
    },
    {
      path: `${seg.section.recycling}/:regionSlug/:citySlug/:recyclingStationAddressSlug/${seg.suffix.recyclingCenter}`,
      loadComponent: () =>
        import(
          '@app/pages/recycling/recycling-station-detail/recycling-detail.component'
        ).then((c) => c.RecyclingStationDetailComponent),
    },
    {
      path: `${seg.section.gardenTrash}/:regionSlug/:citySlug/${seg.suffix.gardenTrash}`,
      loadComponent: () =>
        import(
          '@app/pages/recycling/garden-trash-city/garden-trash-city.component'
        ).then((c) => c.GardenTrashCityComponent),
    },
    {
      path: `${seg.section.bulkTrash}/:regionSlug/:citySlug/${seg.suffix.bulkyWaste}`,
      loadComponent: () =>
        import(
          '@app/pages/recycling/bulk-trash-city/bulk-trash-city.component'
        ).then((c) => c.BulkTrashCityComponent),
    },
  ];
}
